import { get } from "../ajax";

export async function userList(body:Record<string, any>){
    const url = `/api/User/GetUserPageList?Mobile=${body.Mobile}&PageIndex=${body.PageIndex}&PageSize=${body.PageSize}`
    const res = await get(url)
    return res;
}